import {createApi} from './_factory';
import type {ProjectDocumentNs} from '@shared/types';

const api = createApi('project/document');

export const ProjectDocumentApi = {
  list: (data: ProjectDocumentNs.ListRequest) =>
    api.post<ProjectDocumentNs.ListRequest, ProjectDocumentNs.ListResponse>('list', data),

  detail: (data: ProjectDocumentNs.DetailRequest) =>
    api.post<ProjectDocumentNs.DetailRequest, ProjectDocumentNs.ProjectDocumentDetail>('detail', data),

  rename: (data: ProjectDocumentNs.RenameRequest) =>
    api.post<ProjectDocumentNs.RenameRequest, ProjectDocumentNs.ProjectDocument>('rename', data),

  delete: (data: ProjectDocumentNs.DeleteRequest) =>
    api.post<ProjectDocumentNs.DeleteRequest, ProjectDocumentNs.DeleteResponse>('delete', data),

  /** Files straight onto the board — no conversation, no analysis. */
  upload: (data: ProjectDocumentNs.UploadRequest, files: File[]) => {
    const form = new FormData();
    form.append('payload', new Blob([JSON.stringify(data)], {type: 'application/json'}));
    for (const file of files) {
      form.append('files', file, file.name);
    }
    return api.upload<ProjectDocumentNs.UploadResponse>('upload', form);
  },
};
